(function () {
  'use strict';

  var config = window.MOAVIA_MIN_ORDER || {};
  var MIN_TOTAL = config.minimum || 150000;
  var MESSAGE = config.message || 'کام از کام آرڈر کی قیمت 1500 روپے ہونی چاہئیے۔ اپنا آرڈر بارہایوں اور پھر چیک آؤٹ کرین۔';
  var TITLE = config.title || 'کم از کم آرڈر ضروری ہے۔';
  var AMOUNT_LABEL = config.amountLabel || 'آپکا آرڈر کل: [current] | کام از کام زروری: [required]';
  var BTN_TEXT = config.btnText || 'شاپنگ جاری رکھیں';
  var CLOSE_LABEL = config.closeLabel || 'بند کریں';
  var USE_URDU_MONEY = config.useUrduMoney === true;
  var CART_URL = config.cartUrl || '/cart';
  var allowCheckout = false;
  var validating = null;
  var pendingCheckoutForm = null;

  var CHECKOUT_SELECTORS = [
    '[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout"]',
    'a[href*="/checkout"]',
    'form[action="/checkout"] button[type="submit"]',
    'form[action="/checkout"] input[type="submit"]',
    'form[action*="/checkout"]',
    '.shopify-payment-button__button',
    '.shopify-payment-button button',
    '.additional-checkout-button',
    '.cart__checkout-button',
    'shop-pay-wallet-button',
    '[data-shopify="payment-button"] button',
    '#dynamic-checkout-cart button',
    '.dynamic-checkout__content button',
    '.wallet-cart-button-container button',
    '.accelerated-checkout-button'
  ].join(', ');

  function formatMoney(cents) {
    if (USE_URDU_MONEY) {
      var amount = cents / 100;
      return amount.toLocaleString('en-PK') + ' روپے';
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && window.t_moneyFormat) {
      return Shopify.formatMoney(cents, window.t_moneyFormat);
    }
    return config.minimumFormatted || (MIN_TOTAL / 100).toFixed(0);
  }

  function isCheckoutUrl(url) {
    if (!url) return false;
    var str = String(url).toLowerCase();
    return str.indexOf('/checkout') !== -1 || str.indexOf('checkout.shopify.com') !== -1;
  }

  function isCheckoutClick(target) {
    if (!target) return false;
    if (target.matches && target.matches(CHECKOUT_SELECTORS)) return true;
    if (target.closest) {
      if (target.closest(CHECKOUT_SELECTORS)) return true;
      if (target.closest('a[href*="/checkout"]')) return true;
    }
    return false;
  }

  function isCheckoutFormSubmit(form, submitter) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = (form.getAttribute('action') || window.location.pathname || '').toLowerCase();
    if (action.indexOf('/checkout') !== -1) return true;
    if (submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout') return true;
    if (pendingCheckoutForm === form) return true;
    return false;
  }

  function hasUncheckedAgree(form) {
    if (!form) return false;
    var agree = form.querySelector('.js_agree_ck');
    return agree && !agree.checked;
  }

  function fetchCart() {
    if (validating) return validating;
    validating = fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_fetch_failed');
        return res.json();
      })
      .finally(function () {
        validating = null;
      });
    return validating;
  }

  function cartMeetsMinimum(cart) {
    return cart && typeof cart.total_price === 'number' && cart.total_price >= MIN_TOTAL;
  }

  function ensureModal() {
    var modal = document.getElementById('moavia-min-order-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'moavia-min-order-modal';
    modal.className = 'moavia-min-order-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="moavia-min-order-modal__overlay" data-moavia-close></div>' +
      '<div class="moavia-min-order-modal__dialog">' +
      '<button type="button" class="moavia-min-order-modal__close" data-moavia-close aria-label="' + CLOSE_LABEL + '">&times;</button>' +
      '<div class="moavia-min-order-modal__icon" aria-hidden="true">!</div>' +
      '<h3 class="moavia-min-order-modal__title">' + TITLE + '</h3>' +
      '<p class="moavia-min-order-modal__message"></p>' +
      '<p class="moavia-min-order-modal__amount"></p>' +
      '<button type="button" class="moavia-min-order-modal__btn" data-moavia-close>' + BTN_TEXT + '</button>' +
      '</div>';

    var mount = function () {
      if (!document.body) return;
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-moavia-close')) hideModal();
      });
    };

    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) hideModal();
    });

    return modal;
  }

  function showModal(cart) {
    var modal = ensureModal();
    var current = cart ? formatMoney(cart.total_price) : '—';
    var required = formatMoney(MIN_TOTAL);
    modal.querySelector('.moavia-min-order-modal__message').textContent = MESSAGE;
    modal.querySelector('.moavia-min-order-modal__amount').textContent =
      AMOUNT_LABEL.replace('[current]', current).replace('[required]', required);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('moavia-min-order-modal-open');
  }

  function hideModal() {
    var modal = document.getElementById('moavia-min-order-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('moavia-min-order-modal-open');
  }

  function validateCart() {
    return fetchCart().then(function (cart) {
      if (cartMeetsMinimum(cart)) return { ok: true, cart: cart };
      showModal(cart);
      return { ok: false, cart: cart };
    }).catch(function () {
      showModal(null);
      return { ok: false, cart: null };
    });
  }

  function navigateTo(url) {
    window.location.assign(url);
  }

  function guardedNavigate(url) {
    if (allowCheckout || !isCheckoutUrl(url)) {
      navigateTo(url);
      return;
    }
    validateCart().then(function (result) {
      if (!result.ok) return;
      allowCheckout = true;
      navigateTo(url);
      allowCheckout = false;
    });
  }

  function proceedToCheckout(target) {
    allowCheckout = true;
    try {
      if (target.tagName === 'A') {
        window.location.href = target.href;
        return;
      }
      var form = target.closest('form');
      if (form) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(target);
        } else {
          form.submit();
        }
        return;
      }
      window.location.href = '/checkout';
    } finally {
      setTimeout(function () {
        allowCheckout = false;
      }, 0);
    }
  }

  function patchNavigation() {
    var locProto = window.Location && window.Location.prototype;
    if (!locProto) return;

    ['assign', 'replace'].forEach(function (method) {
      var original = locProto[method];
      if (!original) return;
      locProto[method] = function (url) {
        if (allowCheckout || !isCheckoutUrl(url)) {
          return original.call(this, url);
        }
        guardedNavigate(url);
      };
    });

    var hrefDescriptor = Object.getOwnPropertyDescriptor(locProto, 'href');
    if (hrefDescriptor && hrefDescriptor.set) {
      Object.defineProperty(locProto, 'href', {
        configurable: true,
        enumerable: hrefDescriptor.enumerable,
        get: hrefDescriptor.get,
        set: function (url) {
          if (allowCheckout || !isCheckoutUrl(url)) {
            hrefDescriptor.set.call(this, url);
            return;
          }
          guardedNavigate(url);
        }
      });
    }

    var originalOpen = window.open;
    window.open = function (url) {
      if (!allowCheckout && isCheckoutUrl(url)) {
        validateCart().then(function (result) {
          if (result.ok) originalOpen.apply(window, arguments);
          else showModal(result.cart);
        });
        return null;
      }
      return originalOpen.apply(window, arguments);
    };
  }

  function patchFetch() {
    if (!window.fetch) return;
    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!allowCheckout && isCheckoutUrl(url)) {
        return validateCart().then(function (result) {
          if (!result.ok) {
            return Promise.reject(new Error('minimum_order_not_met'));
          }
          allowCheckout = true;
          return originalFetch(input, init).finally(function () {
            allowCheckout = false;
          });
        });
      }
      return originalFetch(input, init);
    };
  }

  function patchXHR() {
    var originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._moaviaUrl = url;
      return originalOpen.apply(this, arguments);
    };

    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var args = arguments;
      if (!allowCheckout && isCheckoutUrl(xhr._moaviaUrl)) {
        validateCart().then(function (result) {
          if (!result.ok) {
            xhr.dispatchEvent(new Event('error'));
            return;
          }
          allowCheckout = true;
          originalSend.apply(xhr, args);
          allowCheckout = false;
        });
        return;
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (e) {
    if (allowCheckout) return;
    if (!isCheckoutClick(e.target)) return;

    var target = e.target.closest(CHECKOUT_SELECTORS) || e.target;
    var form = target.closest('form');
    if (hasUncheckedAgree(form)) return;

    pendingCheckoutForm = form;
    setTimeout(function () {
      pendingCheckoutForm = null;
    }, 1000);

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    validateCart().then(function (result) {
      if (result.ok) proceedToCheckout(target);
    });
  }, true);

  document.addEventListener('submit', function (e) {
    if (allowCheckout) return;
    var form = e.target;
    var submitter = e.submitter || document.activeElement;
    if (!isCheckoutFormSubmit(form, submitter)) return;
    if (hasUncheckedAgree(form)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    validateCart().then(function (result) {
      if (!result.ok) return;
      allowCheckout = true;
      try {
        if (submitter && typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitter);
        } else {
          var checkoutBtn = form.querySelector('[name="checkout"]');
          if (checkoutBtn && typeof form.requestSubmit === 'function') {
            form.requestSubmit(checkoutBtn);
          } else {
            window.location.href = '/checkout';
          }
        }
      } finally {
        setTimeout(function () {
          allowCheckout = false;
        }, 0);
      }
    });
  }, true);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(CHECKOUT_SELECTORS)) {
          node.setAttribute('data-moavia-guarded', 'true');
        }
        if (node.querySelectorAll) {
          node.querySelectorAll(CHECKOUT_SELECTORS).forEach(function (el) {
            el.setAttribute('data-moavia-guarded', 'true');
          });
        }
      });
    });
  });

  function initObserver() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll(CHECKOUT_SELECTORS).forEach(function (el) {
      el.setAttribute('data-moavia-guarded', 'true');
    });
  }

  patchNavigation();
  patchFetch();
  patchXHR();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  window.MoaviaMinOrder = {
    validate: validateCart,
    showModal: showModal,
    getMinimum: function () { return MIN_TOTAL; }
  };
})();
